import styled from "styled-components";
import Colors from "../../global/color";

const StyledNewsletter = styled.div`
  padding: 0 40px;
  max-width: 400px;
  ${({ isMobile }) =>
    isMobile ? "margin: 100px auto;" : "margin: 60px auto 60px auto;"}
  ${(props) => props.customstyles}
`;

const StyledInputWrapper = styled.div`
  ${({ isMobile }) => (isMobile ? "" : "width: 185px;")};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin-bottom: 35px;
`;

const StyledInputWrapperFull = styled.div`
  ${({ isMobile }) => (isMobile ? "" : "width: 387px;")};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin-bottom: 35px;
`;

const StyledNewsletterHeading = styled.div`
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  color: ${Colors.gold};
  font-family: "Ogg-Regular";
  margin-bottom: 10px;

  @media (min-width: 768px) {
    display: block;
    margin-bottom: 10px;
  }
`;

const StyledInput = styled.input`
  font-family: "FuturaPT-Medium";
  border: none;
  border-bottom: 1px solid #999;
  outline: none;
  background: transparent;
  height: 30px;
  width: 100%;
  // margin-bottom: 35px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #000000;

  ::placeholder {
    color: #999;
  }

  &[type="email"] {
    ${({ isMobile }) => (isMobile ? "" : "width: 387px;")}
  }

  @media (min-width: 810px) {
    // margin-right: 25px;
    width: 185px;

    // &:first-child {
    //   margin-right: 25px;
    // }
  }
`;

const StyledErrorMsg = styled.span`
  && {
    font-size: 14px;
    color: red;
    line-height: 14px;
    font-family: FuturaPT-Medium;
    height: 14px;
    padding-top: 10px;
  }
`;

const StyledSubmit = styled.input`
  border: 1px solid #999;
  outline: none;
  background: transparent;
  height: 50px;
  width: 100%;
  color: #000000;
  font-size: 12px;
  line-height: 12px;
  margin: 10px auto;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 500;
  -webkit-transition: color 0.3s ease-out, border-color 0.3s ease-out,
    background 0.3s ease-out;
  -moz-transition: color 0.3s ease-out, border-color 0.3s ease-out,
    background 0.3s ease-out;
  -ms-transition: color 0.3s ease-out, border-color 0.3s ease-out,
    background 0.3s ease-out;
  -o-transition: color 0.3s ease-out, border-color 0.3s ease-out,
    background 0.3s ease-out;
  transition: color 0.3s ease-out, border-color 0.3s ease-out,
    background 0.3s ease-out;
  ${(props) => props.customStyles};
  &:hover {
    text-decoration: none;
    color: #c69f2d;
    border-color: #c69f2d;
    background: #fff;
    cursor: pointer;
  }
  &:disabled {
    opacity: 1;
    cursor: no-drop;
  }
  @media (min-width: 768px) {
    display: block;
    margin: 10px auto;
    max-width: 160px;
  }
`;

const StyledInputRow = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ isMobile }) =>
    isMobile
      ? "flex-direction: column; flex: 1 1 auto;"
      : "flex-direction: row;"}
`;

const StyledCardCaption = styled.div`
  font-size: 14px;
  line-height: 22px;
  font-family: "FuturaPT-Medium";
  color: #000000;
  text-align: center;
  margin: 0 auto 30px auto;
  max-width: 317px;
`;

const HiddenLabel = styled.div`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export {
  StyledNewsletter,
  StyledNewsletterHeading,
  StyledInput,
  StyledSubmit,
  StyledErrorMsg,
  StyledInputWrapper,
  StyledInputRow,
  StyledCardCaption,
  HiddenLabel,
  StyledInputWrapperFull,
};
